import styled from 'styled-components'

export const TableContainer = styled.div<{ background?: string }>`
  align-items: center;
  padding: 10px 0 32px;
  background: linear-gradient(180deg, rgba(233, 238, 246, 0.4) 0%, rgba(255, 255, 255, 0) 100%),
    ${(props) => props.background || 'transparent'};
  overflow-x: auto;
  max-width: 100%;
  border-radius: 24px;

  &.inventory-table {
    padding: 0 0 28px;
    background: transparent;

    > div {
      padding: 16px 12px 12px;
      background: #ffffff;
      border: 0;
      border-radius: 10px;
      box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1) !important;
      overflow: visible;
    }

    table {
      min-width: 0 !important;
    }

    thead {
      background: #eff5fb;
      border-radius: 12px;
      overflow: hidden;
    }

    thead tr {
      border-bottom: 0;
    }

    th:first-child {
      border-radius: 12px 0 0 12px;
    }

    th:last-child {
      border-radius: 0 12px 12px 0;
    }

    th {
      padding: 16px 24px;
      color: #163247;
      font-size: 0.82rem;
      font-weight: 800;
      line-height: 1.2;
      text-align: left;
      text-transform: none;
    }

    td {
      padding: 20px 24px;
      color: #536b84;
      font-size: 0.95rem;
      border-bottom: 1px solid #e5edf4;
      text-align: left;
    }

    tbody tr {
      min-height: 72px;
      background: #ffffff !important;

      &:nth-child(even) {
        background: #ffffff !important;
      }
    }
  }

  &.skills-texts-result-table {
    table {
      min-width: 0 !important;
    }

    col:nth-child(1) { width: 17% !important; }
    col:nth-child(2) { width: 17% !important; }
    col:nth-child(3) { width: 32% !important; }
    col:nth-child(4) { width: 17% !important; }
    col:nth-child(5) { width: 17% !important; }

    td[data-label='Acciones'] {
      padding: 8px 16px;
    }
  }

  &.process-detail-table,
  &.process-detail-users-table {
    padding: 0;
    background: transparent;
    width: 100%;

    > div {
      padding: 0;
      background: #ffffff;
      border: 0;
      border-radius: 0;
      box-shadow: none !important;
      overflow: hidden;
    }

    table {
      min-width: 0 !important;
    }

    col {
      width: auto !important;
    }

    thead {
      background: #eff5fb;
      border-radius: 10px;
      overflow: hidden;
    }

    thead tr {
      border-bottom: 0;
    }

    th:first-child {
      border-radius: 12px 0 0 12px;
    }

    th:last-child {
      border-radius: 0 12px 12px 0;
    }

    th {
      padding: 16px 24px;
      height: 52px;
      box-sizing: border-box;
      color: #163247;
      font-family: 'Public Sans', sans-serif;
      font-size: 0.82rem;
      font-weight: 800;
      line-height: 1.2;
      text-transform: none;
      text-align: left;
      white-space: nowrap;
    }

    th:last-child {
      text-align: center;
    }

    td,
    th {
      border-bottom: 1px solid #e5edf4;
    }

    td {
      padding: 12px 24px;
      height: 64px;
      box-sizing: border-box;
      color: #536b84;
      font-size: 0.95rem;
      line-height: 1.45;
      text-align: left;
      white-space: nowrap;
    }

    td[data-label='Acciones'] {
      text-align: center;

      > div {
        width: 100%;
        justify-content: center;
      }
    }

    tbody tr {
      min-height: 0;
      background: #ffffff;
    }

    tbody tr:last-child td {
      border-bottom: 0;
    }
  }

  &.process-detail-table {
    table {
      width: 100% !important;
      min-width: 0 !important;
      table-layout: fixed;
    }

    col:nth-child(1) { width: 4% !important; }
    col:nth-child(2) { width: 14% !important; }
    col:nth-child(3) { width: 24% !important; }
    col:nth-child(4) { width: 22% !important; }
    col:nth-child(5) { width: 14% !important; }
    col:nth-child(6) { width: 14% !important; }
    col:nth-child(7) { width: 8% !important; }

    td {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &.process-detail-users-table {
    table {
      width: 100% !important;
      min-width: 0 !important;
      table-layout: fixed;
    }

    col:nth-child(3) { width: 14% !important; }
    col:nth-child(4) { width: 20% !important; }
    col:nth-child(5) { width: 14% !important; }
    col:nth-child(6) { width: 14% !important; }
    col:nth-child(7) { width: 14% !important; }
    col:nth-child(8) { width: 12% !important; }

    td {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  @media (min-width: 1200px) {
    width: calc(100% + 24px);
    max-width: calc(100% + 24px);
    margin-left: -12px;
    margin-right: -12px;
  }

  &::-webkit-scrollbar {
    height: 12px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(215, 224, 234, 0.95);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(45, 116, 156, 0.88);
    border-radius: 999px;
    border: 2px solid rgba(255, 255, 255, 0.9);
  }
`

export const TableScrollHint = styled.div`
  margin: 0 0 10px;
  color: #5e7183;
  font-family: 'Public Sans', sans-serif;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  text-align: right;

  @media (min-width: 1201px) {
    display: none;
  }
`

export const TableToolbar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  margin: 5px 0 18px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const TableToolbarLabel = styled.div`
  color: #163247;
  font-family: 'Inter', sans-serif;
  font-size: clamp(1.1rem, 2vw, 1.35rem);
  font-weight: 700;
  line-height: 1.25;
`

export const TableToolbarSearch = styled.div`
  display: flex;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: stretch;
  }
`

export const TableMeta = styled.div`
  margin: 0 0 12px;
  color: #5e7183;
  font-family: 'Public Sans', sans-serif;
  font-size: 0.92rem;
  font-weight: 600;
`

export const TableSurface = styled.div`
  position: relative;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  border: 1px solid #d7e0ea;
  border-radius: 24px;
  box-shadow: 0 18px 40px rgba(23, 55, 77, 0.08);
  overflow-x: auto;
  overflow-y: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 56px;
    height: calc(100% - 12px);
    border-radius: 0 24px 24px 0;
    background: linear-gradient(270deg, rgba(251, 253, 255, 0.98) 0%, rgba(251, 253, 255, 0) 100%);
    pointer-events: none;
    z-index: 2;
  }

  @media (min-width: 1201px) {
    &::after {
      display: none;
    }
  }
`

export const PaginationDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 1.5rem 0 0;

  .MuiPagination-ul {
    gap: 4px;
  }

  .MuiPaginationItem-root {
    border-radius: 12px;
    color: #2d749c;
    font-weight: 700;
  }

  .MuiPaginationItem-root.Mui-selected {
    background: #2d749c;
    color: white;
  }
`

export const Table = styled.table`
  width: 100%;
  text-align: center;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
`

export const TableRow = styled.tr`
  position: relative;
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;

  &:nth-child(even) {
    background-color: rgba(233, 238, 246, 0.35);
  }

  &:hover {
    background-color: rgba(45, 116, 156, 0.06);
    box-shadow: inset 0 0 0 1px rgba(45, 116, 156, 0.08);
  }

  &.selected {
    background: linear-gradient(90deg, rgba(198, 1, 107, 0.1) 0, rgba(198, 1, 107, 0.02) 46px), rgba(198, 1, 107, 0.04);
    box-shadow: inset 4px 0 0 #c6016b;
  }

  &.isEditing {
    background-color: rgba(45, 116, 156, 0.08);
    box-shadow: inset 4px 0 0 #2d749c;
  }
`

export const TableHeaders = styled.thead<{ compact?: boolean }>`
  background: linear-gradient(180deg, #f6fafe 0%, #edf4fa 100%);

  tr {
    border-bottom: 1px solid #d7e0ea;
  }

  th {
    padding: 18px 16px;
    color: #163247;
    font-family: 'Public Sans', sans-serif;
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    line-height: 1.2;
    text-transform: uppercase;
    border-bottom: 1px solid #d7e0ea;
    white-space: ${(props) => (props.compact ? 'normal' : 'nowrap')};
    overflow-wrap: ${(props) => (props.compact ? 'anywhere' : 'normal')};
    text-align: center;
  }

  @media (max-width: 1400px) {
    th {
      padding: 16px 14px;
      font-size: 0.72rem;
    }
  }
`

export const TableHeader = styled.th`
  cursor: pointer;
  user-select: none;
  text-align: center;
`

export const TableCell = styled.td`
  text-align: center;
  width: auto;
  min-width: 0;
  overflow: visible;
  white-space: normal;
  position: relative;
  word-wrap: break-word;
  word-break: normal;
  padding: 16px;
  color: #30485a;
  font-family: 'Inter', sans-serif;
  font-size: 0.94rem;
  line-height: 1.45;
  border-bottom: 1px solid #e5ecf3;
  vertical-align: middle;

  @media (max-width: 1400px) {
    padding: 14px;
    font-size: 0.88rem;
  }
`

export const NumberCell = styled.td`
  width: 60px;
  max-width: 60px;
  min-width: 60px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
  color: #2d749c;
  padding: 16px;
  border-bottom: 1px solid #e5ecf3;

  @media (max-width: 1400px) {
    padding: 14px 12px;
  }
`

export const CheckboxCell = styled.td`
  width: 40px;
  max-width: 40px;
  min-width: 40px;
  text-align: center;
  padding: 16px 10px;
  border-bottom: 1px solid #e5ecf3;

  @media (max-width: 1400px) {
    padding: 14px 8px;
  }
`

export const ActionsCell = styled.td`
  width: auto;
  min-width: 0;
  max-width: none;
  padding: 12px 16px;
  border-bottom: 1px solid #e5ecf3;
  vertical-align: middle;
  white-space: normal;
  overflow: visible;
  text-align: center;

  @media (max-width: 1400px) {
    padding: 12px;
  }
`

export const UpdateLink = styled.a`
  align-items: center;
  justify-content: center;
  color: #2d749c;
  font-weight: bold;
  cursor: pointer;
`

export const TableBody = styled.tbody`
  justify-content: space-between;
  min-height: 400px;
`

export const TextView = styled.span`
  font-family: 'Public Sans', sans-serif;
  color: #c6016b;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  cursor: pointer;
`

export const TextUpdate = styled.span`
  font-family: 'Public Sans', sans-serif;
  justify-content: flex-end;
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  cursor: pointer;
  color: #2d749c;
`

export const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
`
